import { useRef, useState } from "react";
import { UploadSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { fileUrl } from "@/lib/api";

export const ImageUploader = ({ images, onChange }) => {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of Array.from(files)) {
        const fd = new FormData();
        fd.append("file", file);
        const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(r.data.url);
      }
      onChange([...images, ...uploaded]);
      toast.success("Image(s) uploaded");
    } catch (e) {
      toast.error("Upload failed. Try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <div className="grid grid-cols-3 gap-3">
        {images.map((img, i) => (
          <div key={i} className="relative aspect-square overflow-hidden rounded-xl border border-stone-200">
            <img src={fileUrl(img)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`remove-image-${i}`} onClick={() => onChange(images.filter((_, idx) => idx !== i))} className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-black/60 text-white">
              <X size={14} />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid="upload-image-btn"
          onClick={() => inputRef.current?.click()}
          className="flex aspect-square flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-stone-300 text-stone-500 transition-colors hover:border-primary hover:text-primary"
        >
          <UploadSimple size={22} />
          <span className="text-xs">{uploading ? "Uploading..." : "Add"}</span>
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple hidden onChange={(e) => e.target.files && handleFiles(e.target.files)} />
    </div>
  );
};
